import { useTranslation } from 'react-i18next';
import { useResourceSet } from '../../resources';
import { addResourceSet } from './I18nProvider';
import { useLocale } from '../useLocale';
export var useTrans = function useTrans(resourceSetName) {
  var _useLocale = useLocale(),
      locale = _useLocale.locale;

  var _useResourceSet = useResourceSet(resourceSetName, locale),
      loading = _useResourceSet.loading,
      items = _useResourceSet.items;

  if (!loading) {
    addResourceSet(locale, resourceSetName, items);
  }

  var _useTranslation = useTranslation(resourceSetName),
      t = _useTranslation.t;

  return {
    loading: loading,
    t: t
  };
};
export default useTrans;